<template>
  <div class="bg-white">
    <main>
      <alerts />
      <slot />
    </main>
  </div>
</template>

<script>

import Alerts from '@/Components/Alerts.vue';

export default {
  components: {
    Alerts,
  },

  data() {
    return {

    };
  },

  methods: {
  },
};
</script>
